var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyedropper = function SvgEyedropper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillRule: "evenodd",
    d: "m9.62 9.248 1.03 1.016-7.245 7.139-.928-.102-.103-.914zM16.64.166a2.9 2.9 0 0 0-1.967.853L9.362 6.25l-1.083-.153a.73.73 0 0 0-.755.39.71.71 0 0 0 .136.83l.929.914-7.494 7.383a.71.71 0 0 0-.21.587l.206 1.829a.724.724 0 0 0 .645.635l1.856.203c.22.024.44-.052.596-.206l7.494-7.383.928.914c.222.218.56.273.841.134a.72.72 0 0 0 .396-.743l-.154-1.067 5.31-5.232c.653-.644.925-1.47.855-2.224s-.438-1.43-.958-1.942-1.205-.875-1.97-.944a3 3 0 0 0-.29-.01"
  })));
};
export default SvgEyedropper;